import {useRef} from 'react';

/** Keep an unchanged submitted action on the same retry identity until it succeeds. */
export function useRequestIntent(){
  const intent=useRef<{body:string;id:string}|null>(null);
  return {
    id(body:unknown){
      const serialized=JSON.stringify(body);
      if(intent.current?.body!==serialized)intent.current={body:serialized,id:crypto.randomUUID()};
      return intent.current.id;
    },
    clear(){intent.current=null;},
  };
}
